    import React, { useState, useContext } from 'react'
import { motion } from 'framer-motion'

/*COMPONENTS */
import Lottie from 'react-lottie';
import animation from '../../images/animated/Animation - 1736660211116.json'

import Header from '../../components/Header'
import TableList from '../../components/TableList'
import SidebarEl from '../../components/SidebarEl'
import Filter from '../../components/Filter'
import DashboardGrafical from '../../components/DashboardGrafical'
import styled from 'styled-components'
import MobileMenu from '../../components/MobileMenu'
import ModalTag from '../../components/ModalTag'
import ModalClient from '../../components/ModalClient'
import { ToastContainer } from 'react-toastify';
/* CONTEXT */
import { RequestsContext } from '../../context/requests'

const CardWrapper = styled.section`
    background-color: #fafafa;
    height: 100vh;
    display: flex;

   
    .colum_primary{ 
        flex:0.1;
    }


    .colum_secondary{
        display: flex;
        flex:1;
        padding: 1.7rem;
        flex-direction: column;
        width: 100%;
    }

    @media screen and (max-width:720px){
        .colum_primary{ 
        flex:0;
    }

        .colum_secondary{
        display: flex;
        flex:1;
        padding: 1.7rem;
        flex-direction: column;
        width: 100%;
    }
    }

`
const RowDashboard = styled.div`

    display: flex;
    justify-content:space-between; 
    align-items: center;

    @media screen and (max-width:720px){
        width: 100%;
        flex-direction: column;
    }

`
const CleanMobile = styled.div`
@media screen and (max-width:720px){
        display: block;
        height:7rem
    }

`
const FixWidthSidebar = styled.div`
    display: block;
    width: 130px;
    @media screen and (min-width:1800px){
        display: block;
        width: 90px;
    }

    @media screen and (max-width:820px){
        display: none;
    }


`

const Dashboard = () => {
    const defaultOptions = {
        loop: true,
        autoplay: true, 
        animationData: animation,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
    }
    const {
        dashboard,
        inputSearchFocus,
        selectItems,
        setModalPrintItems,
        modalPrintItems,
        get,
        setModalRequestInfo,
        modalRequestInfo,
        haveRequests,
        getAll,
        getDashboard
    } = useContext(RequestsContext)

    const [structure] = useState([
        {
            name: "Selecionar",
        },
        {
            name: "Data",
        },
        {
            name: "N Pedido",
        },

        {
            name: "SKU",
        },

        {
            name: "Produto",
        },

        {
            name:"Código rastreio"
        },
        {
            name:"Site Rastreio"
        },
        {
            name: "Situação",
        },


    ])

    function Modal(props) {
        return (
            <ModalTag props={props} />
        );
    }

    function ModalRequest(props) {
        return (
            <ModalClient props={props} />
        );
    }

    const [filterOption,setFilterOption] = useState(1)

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
        >
            <ToastContainer/>
            <CardWrapper>
                <div className='colum_primary'>
                    <SidebarEl />
                </div>

                <FixWidthSidebar/>

                <div className='colum_secondary'>
                    <Header name="Meus Pedidos" />
                    <Filter
                        type={String(selectItems).length > 0 ? 1 : 3}
                        buttonName={String(selectItems).length > 0 ? "Opções" : "Filtrar"}
                        onClick={() => setModalPrintItems(true)}
                        onChange={(e) => get(e.target.value)}
                    />
                    {inputSearchFocus

                        ?
                        <TableList structure={structure} />
                        :
                        <>

                            <RowDashboard>
                                <DashboardGrafical type={1} value={dashboard?.totalProducts}  name="N Pedidos" />
                                <DashboardGrafical type={2} value={dashboard?.send} name={"Enviados"}  onClick={() => {setFilterOption(2);getAll(5);getDashboard(0,5)} } change={filterOption}  />
                                <DashboardGrafical type={3}  value={dashboard?.productLoss} name={"Em Aberto"} onClick={() => {setFilterOption(1);getAll(1);getDashboard(0,1)} } change={filterOption} />
                            </RowDashboard>
                            
                            <TableList structure={structure} />

                            {haveRequests == false 
                            
                            ?
                            <Lottie options={defaultOptions}
                            height={200}
                            width={200}
                            />
                            :
                            <></>
                            }

                            <CleanMobile />
                        </>
                    }

                </div>

                <Modal
                    show={modalPrintItems}
                    onHide={() => setModalPrintItems(false)}

                />

                <ModalRequest
                    show={modalRequestInfo}
                    onHide={() => setModalRequestInfo(false)}
                />

            </CardWrapper>

            <MobileMenu />
            <CleanMobile />

        </motion.div>
    )
}

export default Dashboard